import {sidebar_action} from "../actions/sidebar";

const inited = {
    display: false
};

export default function sidebarReducer(state = inited, action) {
    switch (action.type) {
        case sidebar_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/sidebar.js